export function formatSuspensionReason(reason, t, namespace) {
    if (!reason) return null;
    if (reason.startsWith('non_payment_overdue:')) {
        const days = parseInt(reason.split(':')[1], 10) || 0;
        return t(`${namespace}.suspensionReasonNonPayment`, {days});
    }
    if (reason === 'deactivated_by_admin') {
        return t(`${namespace}.suspensionReasonAdmin`);
    }
    return reason;
}
